import React from 'react'

export const Error = () => {
  return (
    <div style={{width:"100%", height: "80vh",display:"flex",justifyContent:"center", alignItems:"center"}}>
      <h4>404 Page Not Found</h4>
    </div>
  )
}
